<template>
	<div>
		<FileBuckets v-if="screen === 'buckets'" @loadFileListing="loadFileListing($event)" />
		<FileListing
			v-if="screen === 'listing'"
			:bucketName="bucketName"
			@loadBuckets="loadFileBucket"
			:isFilePicker="isFilePicker"
			@file:selected="$emit('file:selected', $event)"
			@file:multiSelected="$emit('file:multiSelected', $event)"
		/>
	</div>
</template>

<script>
import FileBuckets from "./FileBuckets"
import FileListing from "./FileListing"

export default {
	components: {
		FileBuckets,
		FileListing
	},

	props: {
		isFilePicker: {
			type: Boolean,
			default: () => false
		}
	},

	data() {
		return {
			bucketName: null,
			screen: "buckets"
		}
	},

	methods: {
		loadFileListing(bucketName) {
			this.bucketName = bucketName
			this.screen = "listing"
		},

		loadFileBucket() {
			this.bucketName = null
			this.screen = "buckets"
		}
	}
}
</script>
